module.exports = __webpack_public_path__ + "img/wheel-bg.d183c322.png";